import { combineEpics, ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import cookie from 'react-cookie';
import { each, keys, filter } from 'lodash';

import { updateQueryParams } from 'app/lib/utils';
import { SET_PAGE, SET_PER_PAGE, APPLY_FILTERS, RESET_FILTERS } from './action-types';

const pageParamName = prefix => `${prefix}_page`;
const perPageParamName = prefix => `${prefix}_per_page`;

export const setPageEpic = action$ =>
  action$.pipe(
    ofType(SET_PAGE),
    switchMap(action => {
      const { page, pageParamPrefix } = action.payload;

      cookie.save(pageParamName(pageParamPrefix), page);

      window.location.reload();

      return EMPTY;
    }));

export const setPerPageEpic = action$ =>
  action$.pipe(
    ofType(SET_PER_PAGE),
    switchMap(action => {
      const { perPage, pageParamPrefix } = action.payload;

      cookie.save(pageParamName(pageParamPrefix), 1);
      cookie.save(perPageParamName(pageParamPrefix), perPage);

      window.location.reload();

      return EMPTY;
    }));

export const applyFiltersEpic = action$ =>
  action$.pipe(
    ofType(APPLY_FILTERS),
    switchMap(action => {
      const { values, specialtyName } = action.payload;

      remove_selected_page_cookies();

      Object.entries(values)
        .forEach(([key, value]) => {
          if (!value) {
            cookie.remove(key);
          } else {
            cookie.save(key, value);
          }
        });

      const queryParams = [{
        key:   'specialty_name',
        value: specialtyName
      }];

      if (values.service_specialty_feature) {
        queryParams.push({
          key:   'service_specialty_feature',
          value: values.service_specialty_feature
        });
      }

      updateQueryParams(queryParams, { resetParams: true });

      return EMPTY;
    }));

export const resetFiltersEpic = action$ =>
  action$.pipe(
    ofType(RESET_FILTERS),
    switchMap(action => {
      const { allFilters, specialtyName } = action.payload;

      remove_selected_page_cookies();

      cookie.remove('specialty_name');
      cookie.remove('service_specialty_feature');
      each(allFilters, filter => {
        cookie.remove(filter.cookieName);
      });

      updateQueryParams([{
        key:   'specialty_name',
        value: specialtyName
      }]);

      return EMPTY;
    }));

const remove_selected_page_cookies = () => {
  const selected_pages_cookies = filter(
    keys(cookie.select()),
    cookie_name => /consults_page/g.test(cookie_name)
  );
  each(selected_pages_cookies, cookie.remove);
};

export default combineEpics(setPageEpic, setPerPageEpic, applyFiltersEpic, resetFiltersEpic);
